import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import styles from './styles.css';
import type { IProps } from './models';

export const ArrowIcon: FC<IProps> = ({
    dataTestId,
    className,
    isOpen = true,
    onClick = () => {},
}) => {
    const classNames = cn(
        styles.arrowIcon,
        {
            [styles.arrowIconOpened]: isOpen,
        },
        className
    );

    return (
        <svg
            className={classNames}
            data-test-id={dataTestId}
            fill="none"
            height="24"
            onClick={onClick}
            viewBox="0 0 30 30"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14.8925 17.186L20.4325 11.646L21.1395 12.354L14.8925 18.6L8.64648 12.354L9.35448 11.646L14.8925 17.186Z"
                fill="black"
            />
        </svg>
    );
};
